import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Whether this visitor is enrolled in the hardware-first checkout, read from the boolean
 * 'hardware-first-checkout-2' feature. false or absent means control. All pricing comes from the server.
 *
 * Evaluated on every render (not memoized) so a flag or attribute change picked up by
 * GrowthBookProvider's re-render is reflected immediately, instead of freezing at the
 * value seen on mount.
 */
export default function useHardwareFirstCheckout(): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  if (!isGrowthBookEnabled) {
    return false;
  }
  return getFiGrowthBook().getFeatureValue<boolean>('hardware-first-checkout-2', false);
}
